import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import MTFDelayPaymentTable from "../../Components/ReportTables/MTFDelayPaymentTable";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import { useDebounce } from "../../Components/useDebounce";
import DurationChangeComponent from "./DurationChangeComponent";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function MTFDelayPaymentSideBarReport() {
  const storeToken = localStorage.getItem("ssoToken");
  // const userType = localStorage.getItem("userType").toLowerCase();
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase()
  const [fileType, setFileType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [gridVal, setGridVal] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [errorResp, setErrorResp] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [count, setCount] = useState(0);
  const [noNameFoundError, setNoNameFoundError] = useState("");
  const [blankClientCodeError, setBlankClientCodeError] = useState("");
  const [show, setShow] = useState(false);
  const [noReportFound, setNoReportFound] = useState(false);
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration, setSelectDuration] = useState("")

  const debouncedClientCode = useDebounce(clientCode, 1000);

  useEffect(() => {
    if (debouncedClientCode) {
      searchApiDetail(debouncedClientCode, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }, [debouncedClientCode]);

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  //search api

  const searchApiDetail = async (code, NoPage) => {
    const payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };

    const partnerPayload = {
      clientCode: code,
      page: NoPage,
      pageSize: 10,
    };

    const encPayload =
      userType === "partner" || partnerRoleNew === "partner"
        ? encryptData(JSON.stringify(partnerPayload))
        : AESEncryption(payloadValue);

    try {
      const response = await axiosInstance.post(
        userType === "partner" || partnerRoleNew === "partner"
          ? Partner_Reports.Client_Search_Partner_URL
          : Client_Search.Search_URL,
        userType === "partner" || partnerRoleNew === "partner" ? encPayload : `"${encPayload}"`,
      );

      const res =
        userType === "partner" || partnerRoleNew === "partner"
          ? JSON.parse(decryptData(response?.data))
          : ApiResDecrypt(response?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNoNameFoundError("");
        setClientList((prev) =>
          page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
        );
      } else {
        setNoNameFoundError(res?.message);
      }
    } catch (error) {
      console.error(error);
      setNoNameFoundError(error.message);
    } finally {
      setScrollLoader(false);
      setBlankClientCodeError("");
    }
  };
  //search api end

  const getMTFDelayReport = async (fileType) => {
    setLoader(fileType === "grid");
    setSmallLoaderExcel(fileType === "excel");
    setSmallLoaderPdf(fileType === "pdf");
    setSmallLoaderMail(fileType === "mail");

    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      seg: "stocks",
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.MTFDelayPaymentReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileType === "grid") {
          setGridVal(res?.data.mtfReport);
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else if (fileType === "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileType === "grid") {
          setGridVal([]);
          setNoReportFound(res?.message);
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (fileType === "grid") {
        setNoReportFound(error?.message);
      } else {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  const handleOnClick = (e) => {
    if (clientCode) {
      if (e.target.value) {
        if(selectDuration){
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          // setFileType(e.target.value);
          getMTFDelayReport(e.target.value);
          setErrorResp("");
        } else {
          setErrorResp("Please Select Correct Date");
        }
      }
      else{setErrorResp("Please Select Duration");}
      }
    } else {
      setShow(false);
      setClientList([]);
      setBlankClientCodeError("*Please Enter Client Name/Code");
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }
  const handleFromDateChange = (e) => {
    // setFileType("");
    setNoReportFound(false);
    setGridVal([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
  };
  const handleToDateChange = (e) => {
    setNoReportFound(false);
    // setFileType("");
    setGridVal([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
  };

  const handleScroll = async (e) => {
    const element = e.target;
    if (
      element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
      !scrollLoader
    ) {
      if (count > 10 * page) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  // useEffect(() => {
  //   if (fileType !== "") {
  //     getMTFDelayReport();
  //   }
  // }, [fileType]);
  const onChangeDuration = () => {
    setNoReportFound(false);
    setGridVal([]);
    setErrorResp(false);

  }
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Delay_Payment_Report}</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-12">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                      setNoReportFound(false);
                      setBlankClientCodeError(false);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={handleScroll}
                    >
                      {clientList.map((item, i) => (
                        <li
                          key={i}
                          className="rm-maping-item-wrapper"
                          onClick={() => {
                            setClientCode(item?.clientCode);
                            setShow(false);
                          }}
                        >
                          {userType === "partner" || partnerRoleNew === "partner" ? 
                                <>
                                  <div> {item?.clientName}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              : 
                                <>
                                  <div> {item?.clientname}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              }
                        </li>
                      ))}
                      {scrollLoader && !loader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {noNameFoundError && !scrollLoader && (
                        <li
                          className="rm-maping-item-wrapper"
                          style={{ borderBottom: "none", fontSize: "12px" }}
                        >
                          {noNameFoundError}
                        </li>
                      )}
                    </ul>
                  )}
                </div>
                {blankClientCodeError && (
                  <span className="to-date-error">{blankClientCodeError}</span>
                )}
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-12">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div>
            {customShow && <div className="col-md-3 col-sm-3 col-12">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}
            {customShow &&
              <div className="col-md-3 col-sm-3 col-12">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>}
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            <ReportTableHeader
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
              showEmailBtn={true}
              smallLoaderMail={smallLoaderMail}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : gridVal && gridVal.length > 0 ? (
              <div>
                <MTFDelayPaymentTable gridVal={gridVal} />
              </div>
            ) : (
              noReportFound && (
                <h4 className="report-error-message">
                  {noDataFound(noReportFound)}
                </h4>
              )
            )}
          </div>
        </div>
      </main>
    </>
  );
}
export default MTFDelayPaymentSideBarReport;
